export default "__VITE_ASSET__DFpoxYld__"